export default __webpack_public_path__ + "static/media/248104.40f1a2f3.webp";